import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PlatformMode } from '../models/platform-mode.model';

@Injectable({ providedIn: 'root' })
export class PlatformModeService {
  constructor(private router: Router) {}

  getMode(): PlatformMode {
    let route: ActivatedRoute | null = this.router.routerState.root;
    while (route) {
      const value = route.snapshot.data['mode'] as PlatformMode | undefined;
      if (value) return value;
      route = route.firstChild;
    }
    return PlatformMode.WEB;
  }
}
